import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { sportsHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/sportsHelpers";
import { _sportsOriginTypes } from "projectSpecific/sports/cnr/reducers/SportsReducer";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { DatabaseContext } from "../../../global/cnr/contexts/DatabaseContext";
import { _showAppLogs } from "../../../global/cnr/contexts/LogContext";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import { useCacheDataManager } from "../../../global/cnr/contexts/useHelpers/cacheDataManager";
import { useMultiDoc } from "../../../global/cnr/contexts/useHelpers/useMultiDoc";
import { dataItems_district } from "projectSpecific/sports/cnr/reducers/SportsDistrictReducer";
import { dataItems_sportsSeason } from "projectSpecific/sports/cnr/reducers/SportsSeasonReducer";
import { SportsSeasonContext } from "../cnr/contexts/SportsSeasonContext";
import { AppTimestampContext } from "global/cnr/contexts/AppTimestampContext";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";

export const _logcons = {
  // ♻️ recycleGreen
  // ⚠️ alter
  // ⚡lightning
  // ✅ checkGreen 
  // ✔️ check
  // ❌ delete
  // ➡️ arrowRight
  // ⬆️ arrowUp
  // ⬇️ arrowDown
  // ⬛ Black
  // ⬜ White
  // 🌐 web
  // 🎨 pallette
  // 👇 pointerDown
  // 👉 pointerLeft
  // 💡 bulb
  // 💾 database
  // 📁 folder
  // 📝 note
  // 📡???
  // 📦 box
  // 🔁 recycleBlue
  // 🔄 recycleRound
  // 🔍 magnify
  // 🔑 key
  // 🔒 lock
  // 🔥 fire
  // 🔹 diamond
  // 🗄️cacheFile
  // 🧠 brain
  // 😄 smile
  // 🙂 smileEyes
  // 🚨 siren
  // 🚫 Ban
  // 🟥 Red
  // 🟦 Blue
  // 🟧 Orange
  // 🟨 Yellow
  // 🟩 Green
  // 🟪 Purple
  // 🟫 Brown
  // 1️⃣ one
  // 2️⃣ two
  // 3️⃣ three
  // ⏰ alarm
  // 🕒 clockfase
  // ⏱️ stopwatch
  // 🕰️ mantle
  // 🕒
  // 🌐 web
  red: '🟥',

}

export const _matchSeasonalCollection = 'matches_seasonal'

const _applyCache = true

const dataItems_organization = {
  schools: { collectionName: 'schools' },
}

export const _sportsInfoTypes = {
  organizations: 'organizations',
  districts: 'districts',
  sportsSeason: 'sportsSeason',
}

export const useSportsInfo = ({ sportsInfoType, existingData, sports }) => {

  const cache_groupType = sportsInfoType + 'Info';

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, page_state, currentSettings_state } = states ?? {}

  const appTimestampContext = useContext(AppTimestampContext);
  const { appTimestamp_state } = appTimestampContext ?? {}
  const { timestampInfo } = appTimestamp_state ?? {}
  const { timestamps, timestampsFetched } = timestampInfo ?? {}
  const timestamp = timestamps?.[cache_groupType]
  const _forceUpdate = !timestamp ? true : false

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { teams_info } = sportsSeason_state ?? {}

  const { handleGet_multiDocs } = useMultiDoc()

  const cdm = useCacheDataManager()

  const { view, pathViews } = paps_state ?? {}
  const { events: eventKey, sports: sportsKey } = pathViews ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { sportPermissions } = aps_global ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}

  const { dataSource } = viewItem ?? {}
  const { dataParents, useSeasonals } = dataSource ?? {}

  const [districtInfo, setDistrictInfo] = useState({})
  const [organizationInfo, setOrganizationInfo] = useState({})
  const [sportInfo, setSportInfo] = useState({})

  // Guard to prevent multiple fetches
  const [initialized, setInitialized] = useState(false);

  const sportMode = useMemo(() => {
    if (sports) {
      let _smk;
      if (sports && sportsKey) {
        if (sports && sports[sportsKey]) {
          const x = sports[sportsKey]
          _smk = _.camelCase(x.name)
        } else {
          _smk = sportsKey
        }
      }
      const sportsSeasonInfo = sportsHelpers.getSportSeasonType(_smk)
      return sportsSeasonInfo
    }
    return {}
  }, [sports])

  const handle_organizationInfo = async ({ organization, organizationData, fromCache }) => {
    const fullData = { organization, organizationData }
    const _organizationtData = unwrapObject(organizationData, dataItems_organization)
    const organizationInfo = { ..._organizationtData, organization }
    console.log(`${fromCache ? '🔁' : '🔥'}✅ ${sportsInfoType}`, organizationInfo)
    setOrganizationInfo(organizationInfo)
    await cdm.mergeToGroup(cache_groupType, organization._itemKey, fullData, null, _forceUpdate);
  }

  const handle_districtInfo = async ({ district, districtData, fromCache }) => {
    const fullData = { district, districtData }
    const _districtData = unwrapObject(districtData, dataItems_district)
    const districtInfo = { ..._districtData, district }
    console.log(`${fromCache ? '🔁' : '🔥'}✅ ${sportsInfoType}`, districtInfo)
    setDistrictInfo(districtInfo)
    await cdm.mergeToGroup(cache_groupType, district._itemKey, fullData, null, _forceUpdate);
  }

  const handle_sportsInfo = async ({ sport, sportData, parentDataKeys, fromCache }) => {
    const fullData = { sport, sportData }
    const _sportData = unwrapObject(sportData, dataItems_sportsSeason)
    const sportInfo = { ..._sportData, sport, sportMode }
    console.log(`${fromCache ? '🔁' : '🔥'}✅ ${sportsInfoType}`, sportInfo)
    await cdm.mergeToGroup(cache_groupType, sport._itemKey, fullData, null, _forceUpdate);
    setSportInfo(sportInfo)
  }

  const unwrapByKey = (obj, key) => _.get(obj, key, obj)

  const unwrapObject = (obj, sportDoc) =>
    _.transform(obj, (acc, value, key) => {
      const sd = sportDoc?.[key]
      const { renderAs } = sd ?? {}
      const _key = renderAs || key
      acc[key] = _.get(value, _key, value)
    }, {})

  useEffect(() => {
    setInitialized(false);
  }, [eventKey]);

  useEffect(() => {
    // if (existingData) return;

    if (existingData) {
      // _showAppLogs.sportInfo && console.log(`♻️💾✅ Loaded ${sportsInfoType} from existing`);
      setSportInfo(existingData)
      return;
    }

    if (!pathViews || !database_fns || initialized || !pathViews.events) return;
    if (sportsInfoType === _sportsInfoTypes.sportsSeason && !sports) return;

    // switch (sportsInfoType) {
    //   case _sportsInfoTypes.sportsSeason:
    //     if (teams_info) return
    // }

    setInitialized(true);

    (async () => {

      const additionalDataParents = []

      const pkcProps = {
        pathViews,
        dataParents,
        additionalDataParents,
        data_cache: {},
        database_fns,
        ignoreCache_all: true,
      }


      const getDataFromData = (data_pure) => {
        const items = {}
        _.forEach(data_pure, (dpi, dpiKey) => {
          items[dpiKey] = dpi?.data?.[dpi?.opts?.renderAs ? dpi.opts.renderAs : dpi._dataItemKey]
        })
        return items
      }

      const handleSet_sportsOrganization = (organization) => {
        const cb_organization = async (organizationData) => {
          handle_organizationInfo({ organization, organizationData })
        }
        const _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports'])
        handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_organization, pathViews, pks: _pks, callback: cb_organization })
      }

      const handleSet_sportsDistrict = (district) => {
        const cb_district = async (districtData) => {
          handle_districtInfo({ district, districtData })
        }
        const _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports'])
        handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_district, pathViews, pks: _pks, callback: cb_district })
      }

      const handleSet_sportsSeason = (sport) => {
        const { latestSeason } = sport ?? {}
        const cb_sports = async (sportData, parentDataKeys) => {
          handle_sportsInfo({ sport, sportData, parentDataKeys })
        }
        const _pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey)
        handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_sportsSeason, pathViews, pks: _pks, callback: cb_sports })
      }

      try {
        switch (sportsInfoType) {
          case _sportsInfoTypes.organizations:
            getData_singleDoc(cdm, sportsInfoType, cache_groupType, pathViews, pathViews.organizations, 'organizations', true, database_fns, handle_organizationInfo, handleSet_sportsOrganization)
            break;

          case _sportsInfoTypes.districts:
            getData_singleDoc(cdm, sportsInfoType, cache_groupType, pathViews, pathViews.districts, 'districts', true, database_fns, handle_districtInfo, handleSet_sportsDistrict)
            break;

          case _sportsInfoTypes.sportsSeason:
            getData_singleDoc(cdm, sportsInfoType, cache_groupType, pathViews, sportsKey, 'sports', false, database_fns, handle_sportsInfo, handleSet_sportsSeason)
            break;
        }

      } catch (err) {
        console.error(`❌ Failed to fetch event data`, err);
      }
    })();
  }, [sportsInfoType, sports]);

  // ------------------- Memoized stable return -------------------
  const districtsInfo = useMemo(
    () => (districtInfo),
    [districtInfo]
  );

  const organizationsInfo = useMemo(
    () => (organizationInfo),
    [organizationInfo]
  );

  const sportsInfo = useMemo(
    () => (sportInfo),
    [sportInfo]
  );


  switch (sportsInfoType) {
    case _sportsInfoTypes.organizations:
      return organizationsInfo;
    case _sportsInfoTypes.districts:
      return districtsInfo;
    case _sportsInfoTypes.sportsSeason:
      return sportsInfo;
  };
}

const getData_singleDoc = async (cdm, sportsInfoType, cacheType, pathViews, pathKey, collectionName, ignoreId, database_fns, callback_cache, callback_data) => {
  const cache_result = await cdm.getSubItem(cacheType, pathKey);
  if (_applyCache && !_.isEmpty(cache_result)) {
    callback_cache({ ...cache_result, fromCache: true })
    return;
  }
  const _refPath = createRefPath_event(pathViews, [collectionName, pathKey])
  // _showAppLogs.sportInfo && console.log(`🔥➡️ Fetching doc ${sportsInfoType}/${cacheType} from database (${_refPath})`);
  database_fns.get_doc({ refPath: _refPath, opts: { ignoreId: ignoreId }, callback: callback_data })
}

// const ammend_sportsSeason_datas = (sportsData, sports, latestSeason, pathViews, parentDataKeys, isNew) => {
//   let _smk;
//   if (sports && pathViews.sports) {
//     if (sports && sports[pathViews.sports]) {
//       const x = sports[pathViews.sports]
//       _smk = _.camelCase(x.name)
//     } else {
//       _smk = pathViews.sports
//     }
//   }
//   const sportsSeasonInfo = sportsHelpers.getSportSeasonType(_smk)
//   const sportsSeason_datas = seasonalHelpers.ammend_sportsSeasonDataz(sportsData, latestSeason)
//   if (sportsSeason_datas.playoffTemp) {
//     sportsSeason_datas.playoff_info = sportsSeason_datas.playoffTemp
//   }
//   sportsSeason_datas.parentDataKeys = parentDataKeys
//   sportsSeason_datas.sportsSeasonInfo = sportsSeasonInfo
//   sportsSeason_datas.sportsKey = pathViews.sports
//   sportsSeason_datas.lastestSeason = sports.latestSeason
//   return sportsSeason_datas
// }

// const getTeamRecord = (team, matches) => {

//   const { name, _itemKey, record } = team

//   const matches_team = _.filter(matches, function (m) {
//     return m && m.home && m.away && (m.home.id === _itemKey || m.away.id === _itemKey);
//   })

//   const _rstz = {
//     section: {
//       wins: getFilteredMatchResults(matches_team, _itemKey, 'win', true),
//       losses: getFilteredMatchResults(matches_team, _itemKey, 'lost', true),
//     },
//     nonSection: {
//       wins: getFilteredMatchResults(matches_team, _itemKey, 'win'),
//       losses: getFilteredMatchResults(matches_team, _itemKey, 'lost'),
//     }
//   }

//   const _nonResults = {
//     section: getFilteredMatchNonResults(matches_team, _itemKey, true),
//     nonSection: getFilteredMatchNonResults(matches_team, _itemKey, false),
//   }

//   const teamResults = {
//     section: {
//       wins: _.map(_rstz.section.wins, match => ({
//         opponent: match.away.id === _itemKey ? match.home : match.away,
//         score: match._results.score,
//         sections: match.sections
//       })),
//       losses: _.map(_rstz.section.losses, match => ({
//         opponent: match.away.id === _itemKey ? match.home : match.away,
//         score: match._results.score,
//         sections: match.sections
//       })),
//     },
//     nonSection: {
//       wins: _.map(_rstz.nonSection.wins, match => ({
//         opponent: match.away.id === _itemKey ? match.home : match.away,
//         score: match._results.score,
//         sections: match.sections
//       })),
//       losses: _.map(_rstz.nonSection.losses, match => ({
//         opponent: match.away.id === _itemKey ? match.home : match.away,
//         score: match._results.score,
//         sections: match.sections
//       })),
//     }
//   }
// }
